import { GetUserResponse } from "@/services/datatypes/api";
import { TYPO3_BASE_URL } from "@/services/globals";

export const useGetUser = () => {
    const getUser = async (token: string | null): Promise<GetUserResponse> => {
        try {
            const result = await fetch(`${TYPO3_BASE_URL}user/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Authorization': `Bearer ${token}`,
                },
            });
            if (!result.ok) {
                console.error(`HTTP error! status: ${result.status}`);
                throw new Error('Failed to fetch');
            }
            const responseJson = await result.json();
            const response = { ...responseJson, ok: result.ok };
            return response;
        } catch (error) {
            console.error("Fetch error:", error);
            throw error;
        }
    }
    return { getUser }
}